import jHome from '@/views/home/jHome';
import jHomeSiswa from '@/views/home/jHomeSiswa';
import auth from '@/middleware/auth';
import log from '@/middleware/log';

export default [
  {
    path: '/home',
    name: 'jHome',
    component: jHome,
    meta: {
      title: 'Home',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/home-siswa',
    name: 'jHomeSiswa',
    component: jHomeSiswa,
    meta: {
      title: 'Home Siswa',
      middleware: [auth, log],
      layout: 'jHomeSiswaWrapper',
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/jRouterHome.js